
function AboutPage() {
	return (
		<div className='about-text'>
			<p>Hey!
			<br></br><br></br>
			Welcome to BEAMY, the learning app that empowers you to design 
			and share flashcard decks, acquire knowledge, and keep track of your progress. 
			It's entirely free and always will be. 
			<br></br><br></br>
			The app's creator, <a href="https://github.com/uuuuuvika" className="blue-text">uuuuuvika</a>, 
			designed it as a tribute to Beamy, the brightest pet rat.
            </p>
		</div>
	);
}

export default AboutPage;